import { Tag } from "lucide-react";
import DOMPurify from 'dompurify';

interface EventHeaderProps {
  image: string;
  title: string;
  description: string;
  tags: string[];
  children?: React.ReactNode;
}

const EventHeader = ({ image, title, description, tags, children }: EventHeaderProps) => (
  <>
    <img 
      src={image} 
      alt={title} 
      className="w-full h-48 object-cover"
    />
    
    <div className="p-4 max-w-md mx-auto">
      <div className="flex flex-wrap gap-2 mb-4">
        {tags.map((tag) => (
          <span key={tag} className="bg-primary-light text-primary px-3 py-1 rounded-full text-sm flex items-center">
            <Tag className="w-4 h-4 mr-1" />
            {tag}
          </span>
        ))}
      </div>

      <h1 className="text-2xl font-bold text-primary-dark mb-2">{title}</h1>
      {children}
      <div 
        className="text-gray-600 mb-4 whitespace-pre-wrap font-sans prose prose-sm max-w-none"
        dangerouslySetInnerHTML={{ 
          __html: DOMPurify.sanitize(description.replace(/\n/g, '<br/>')) 
        }} 
      />
    </div>
  </>
);

export default EventHeader;
